import _window from "@src/libraries/window";
import { getBugsnag } from "@src/plugins/bugsnag";
import routesStore from "@src/store/routes";
function report(message, optionalParams = {}, severity) {
    if ("401" == message || "403" == message) {
        console.log("ignored message 401 || 403");
        return;
    }
    if ("[bugsnag]" == message) {
        console.log('"[bugsnag]" == message');
        return;
    }
    if (!message) {
        message = "empty " + typeof message;
    }
    const cordova = _window.cordova;
    const data = {
        metaData: {
            client: process.client,
            nuxtVersion: process.env.VERSION,
            path: routesStore.fullPath,
            cordova: (cordova && cordova.getAppVersion && cordova.getAppVersion.getVersionNumber()) || !!cordova || !!_window["_cordovaNative"] || !!_window["_nativeReady"] || !!_window["cordova_iab"],
            device: _window.device,
            ...optionalParams
        }
    };
    if (severity)
        data.severity = severity;
    let error;
    if (message instanceof Error) {
        error = message;
    }
    else {
        if ("object" == typeof message) {
            try {
                message = JSON.stringify(message);
            }
            catch (e) { }
        }
        error = new Error("" + message);
    }
    return new Promise(resolve => {
        getBugsnag().then(bugsnag => {
            if (!bugsnag) {
                console.warn("!bugsnag", message, optionalParams);
                resolve();
                return;
            }
            try {
                bugsnag.notify(error, (event) => {
                    for (const key in data.metaData) {
                        event.addMetadata("extra", key, data.metaData[key]);
                    }
                }, resolve);
            }
            catch (e) {
                resolve();
            }
        });
    });
}
export default report;
export async function silentReport(e, args) {
    console.log("silentReport", e, args);
    const msg = "object" == typeof e ? e.message : e || e;
    if ("Unhandled promise rejection" == msg) {
        console.warn("Unhandled promise rejection");
        return;
    }
    ;
    if ("string" == typeof e) {
        e = "Silent error: " + e;
    }
    if ("object" == typeof e) {
        try {
            e.message = "Silent error: " + e.message;
        }
        catch (e) {
        }
    }
    await report(e, args, "info");
}
